import { render } from "./SidebarIcon.vue?vue&type=template&id=438bf7a7"
import script from "./SidebarIcon.vue?vue&type=script&lang=js"
export * from "./SidebarIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__